/* Signora (21 Oct 2026): label every journal table cell with its column heading, so phones can show
   each row as a card (CSS in sjw-readability.css). Desktop keeps the normal table. */
(function () {
  function run() {
    document.querySelectorAll('.sjwa-body table').forEach(function (t) {
      var heads = Array.prototype.map.call(t.querySelectorAll('thead th'), function (th) { return th.textContent.trim(); });
      if (!heads.length) return;
      t.classList.add('sjw-tcards');
      t.querySelectorAll('tbody tr').forEach(function (tr) {
        Array.prototype.forEach.call(tr.children, function (td, i) {
          if (!td.hasAttribute('data-label')) td.setAttribute('data-label', heads[i] || '');
        });
      });
    });
  }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();
/* Signora (21 Oct 2026): on phones the Loupe films frame bends out to the card edge where the films
   scroll in and out, instead of a straight line cutting across the next film. The SVG is redrawn from
   the real position of the film row, so it follows any card size. Desktop keeps the CSS frame. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var NS = 'http://www.w3.org/2000/svg';
  function draw(inner) {
    var svg = inner.querySelector(':scope > svg.sjw-lf__frame');
    var track = inner.querySelector('.sjw-lf__track');
    if (!mq.matches || !track) { if (svg) svg.remove(); inner.classList.remove('sjw-lf__in--bent'); return; }
    if (!svg) {
      svg = document.createElementNS(NS, 'svg'); svg.setAttribute('class', 'sjw-lf__frame'); svg.setAttribute('aria-hidden', 'true');
      svg.appendChild(document.createElementNS(NS, 'path')); inner.insertBefore(svg, inner.firstChild);
    }
    var b = inner.getBoundingClientRect(), t = track.getBoundingClientRect();
    var W = b.width, H = b.height, i = 12, r = 16, k = 12;
    var y1 = Math.max(i + r + k, t.top - b.top + 2), y2 = Math.min(H - i - r - k, t.bottom - b.top - 4);
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    var d = 'M' + W + ' ' + y1 + ' A' + k + ' ' + k + ' 0 0 1 ' + (W - i) + ' ' + (y1 - k) +
      ' V' + (i + r) + ' A' + r + ' ' + r + ' 0 0 0 ' + (W - i - r) + ' ' + i +
      ' H' + (i + r) + ' A' + r + ' ' + r + ' 0 0 0 ' + i + ' ' + (i + r) +
      ' V' + (H - i - r) + ' A' + r + ' ' + r + ' 0 0 0 ' + (i + r) + ' ' + (H - i) +
      ' H' + (W - i - r) + ' A' + r + ' ' + r + ' 0 0 0 ' + (W - i) + ' ' + (H - i - r) +
      ' V' + (y2 + k) + ' A' + k + ' ' + k + ' 0 0 1 ' + W + ' ' + y2;
    svg.firstChild.setAttribute('d', d);
    inner.classList.add('sjw-lf__in--bent');
  }
  function all() { document.querySelectorAll('.sjw-lf__in').forEach(draw); }
  if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
  window.addEventListener('load', all);
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(function () { all(); });
    document.querySelectorAll('.sjw-lf__in').forEach(function (el) { ro.observe(el); });
  } else { window.addEventListener('resize', all); }
  mq.addEventListener ? mq.addEventListener('change', all) : mq.addListener(all);
})();

/* Signora (1 Nov 2026): floating "Filter" button without a page jump. On phones the theme pins the real Filter
   button to the bottom of the screen once its bar scrolls away (class is-fixed) and puts it back on the way up;
   each move counted as a layout shift (~0.03 down, ~0.06 back up). Now a copy of the button floats and is only
   shown or hidden, and the real one stays in its place. The theme marks pinning on the wrapper's min-height
   ("NNpx" pinned, "auto" not). Tapping the copy clicks the real button, so the theme opens its filter drawer. */
(function () {
  function setup() {
    var orig = document.querySelector('.product-filters .js-filter-menu-opener:not(.sjw-filter-float)');
    if (!orig || orig.sjwFloat) return;
    var wrap = orig.closest('.js-filter-menu-opener-wrapper') || orig.parentElement;
    var copy = orig.cloneNode(true);
    copy.classList.remove('js-filter-menu-opener');
    copy.classList.add('sjw-filter-float', 'is-fixed');
    // without the theme's toggle hooks, or the theme opens the drawer from the copy too and our click shuts it again
    ['id', 'data-js-toggle', 'data-target', 'data-opener', 'aria-controls'].forEach(function (a) { copy.removeAttribute(a); });
    copy.style.display = 'none';
    orig.insertAdjacentElement('afterend', copy);
    orig.sjwFloat = copy;
    copy.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      setTimeout(function () { orig.click(); }, 0);
    });
    function show(on) {
      copy.style.display = on ? '' : 'none';
    }
    function pinned() {
      if (orig.classList.contains('is-fixed')) {
        orig.classList.remove('is-fixed');
        show(true);
      }
    }
    new MutationObserver(pinned).observe(orig, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(function () {
      if (!wrap.style.minHeight || wrap.style.minHeight === 'auto') show(false);
    }).observe(wrap, { attributes: true, attributeFilter: ['style'] });
    pinned();
  }
  function run() {
    if (!document.querySelector('.product-filters .js-filter-menu-opener')) return; // only collection / search pages
    setup();
    // filter changes re-render the collection header: drop copies whose button is gone, then set up again
    var root = document.querySelector('main') || document.body;
    new MutationObserver(function () {
      document.querySelectorAll('.sjw-filter-float').forEach(function (c) {
        var o = c.previousElementSibling;
        if (!o || o.sjwFloat !== c) c.remove();
      });
      setup();
    }).observe(root, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* Signora (2 Nov 2026): cart page + cart drawer.
   1) The cart note (snippets/cart-footer, data-sjw-cart-promise) is decided in Liquid for USD carts; for other
      currencies compare the cart total with US$500 converted by Shopify.currency.rate.
   2) On phones the chat bubble sat on top of the PayPal button: hide the bubble while the cart's checkout buttons
      are on screen (same ::part rule as the footer hide in sjw-footer.css); it comes back when they scroll away. */
(function () {
  function promises() {
    var rate = (window.Shopify && Shopify.currency && Number(Shopify.currency.rate)) || 1;
    document.querySelectorAll('[data-sjw-cart-promise]').forEach(function (p) {
      if (p.getAttribute('data-currency') === 'USD' || p.__sjwDone) return;
      p.__sjwDone = true;
      var free = Number(p.getAttribute('data-total')) >= 50000 * rate;
      var a = p.querySelector('[data-sjw-promise-free]'), b = p.querySelector('[data-sjw-promise-base]');
      if (a) a.hidden = !free;
      if (b) b.hidden = free;
    });
  }
  function chatAway() {
    var box = document.querySelector('.cart-template__total');
    if (!box || !('IntersectionObserver' in window)) return;
    var css = document.createElement('style');
    css.textContent = '@media (max-width:767px){html[data-sjw-paybtn-inview] shopify-chat::part(activator),html[data-sjw-paybtn-inview] shopify-agent::part(activator){visibility:hidden!important;opacity:0!important;pointer-events:none!important}}';
    document.head.appendChild(css);
    new IntersectionObserver(function (es) {
      var on = es.some(function (e) { return e.isIntersecting; });
      if (on) document.documentElement.setAttribute('data-sjw-paybtn-inview', '');
      else document.documentElement.removeAttribute('data-sjw-paybtn-inview');
    }).observe(box);
  }
  function run() {
    promises();
    chatAway();
    new MutationObserver(function () { if (document.querySelector('[data-sjw-cart-promise]')) promises(); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
